<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { useThemeStore } from '@/stores/themeStore'
import { useAuthStore } from '@/stores/authStore'

import Message from 'primevue/message';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Skeleton from 'primevue/skeleton';

import { LoginWidget } from 'vue-tg'
import { useUserStore } from '@/stores/userStore'
import { useRoute, useRouter } from 'vue-router'
import type { UserAuthRequest } from '@/services/auth-v2-service/types'
import type { RefAgentUrlResponse } from '@/services/user-v2-service/types'
import type { LoginWidgetUser } from 'vue-tg'
// import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { MAIN_ROUTER_PAGE } from '@/utils/consts'
import { useMyToast } from '@/composable/useMyToast';
import { i18n } from "@/i18n";

const route = useRoute()
const router = useRouter()
const themeStore = useThemeStore()
const authStore = useAuthStore()
const userStore = useUserStore()
const errorText = ref<string | null>()

const authBot = computed(() => { return import.meta.env.VITE_BOT_USERNAME })
const refAgent = ref<string | null>()
const refKey = ref<string | null>(null)
const refUrls = ref<RefAgentUrlResponse[]>([
  {
    channel_link: 'fobiumtrade',
    ref_agent: {
      title: 'FBMTrade'
    }
  }
])

const { addToast } = useMyToast()
const { t } = i18n.global

onMounted(async () => {
  await authStore.check()
  if (authStore.authorized) {
    router.push(MAIN_ROUTER_PAGE)
    return
  }
  window.setTimeout(() => {
    addToast({
      severity: "error",
      message: t('welcomeLoginMessage')
    })
  }, 5000)
  const refParam = route.query.ref
  if (refParam && typeof refParam === 'string') {
    refKey.value = refParam
  }

  // if (route.hash.indexOf('#by=') === 0) {
  //   refAgent.value = route.hash.slice(4)
  //   const data = await userStore.getRefUrls(refAgent.value)
  //   if (data) {
  //     refUrls.value.push(...data)
  //   }
  // }

  // if (route.query.dev === 'yyy') {
  //   window.location.href = "https://sr.fobium.trade/?dev-yyy=1"
  //   return
  // }

  // const token = route.query.token
  // if (token) {
  //   localStorage.setItem("token", token.toString())
  //   router.push(MAIN_ROUTER_PAGE)
  //   return
  // }
})

const colorSchemeIcon = computed(() => themeStore.mode == 'dark' ? 'pi pi-moon' : 'pi pi-sun')

interface ExtendedUserData extends LoginWidgetUser {
  invited_by: string
  ref: string
}

const handleUserAuth = async (e: LoginWidgetUser) => {
  const user = e as ExtendedUserData
  if (refAgent.value) {
    user['invited_by'] = refAgent.value
  }
  await authStore.authTg(user as UserAuthRequest, refKey.value ?? null)
  if (authStore.error.auth) {
    if (authStore.error.auth.message.detail[0]?.type == 'user_not_in_channel') {
      errorText.value = 'login.error.subsError'
    } else {
      errorText.value = 'login.error.unknownError'
    }
  } else {
    router.push(MAIN_ROUTER_PAGE)
    errorText.value = null
  }
}
</script>

<template>
  <div>
    <div class="absolute bottom-auto top-0 end-0">
      <!-- <LanguageSwitcher class="m-3" /> -->
      <Button :icon="colorSchemeIcon" class="m-3" @click="themeStore.toggle()" variant="text" rounded
        aria-label="Theme" />
    </div>
    <div class="flex items-center justify-center mt-15 lg:mt-30">
      <div class="w-300 px-10 lg:px-5">
        <span class="font-bold text-5xl">Spread Racer</span>
        <p class="mb-0 mt-3 text-2xl">{{ $t("message.loginMessagePre") }}</p>
        <div class="flex gap-3 mt-2">
          <template v-if="userStore.loading.refUrls">
            <Skeleton height="32px" width="137px"></Skeleton>
          </template>
          <template v-else>
            <a v-for="link, idx in refUrls" :key="idx" :href="`https://t.me/${link.channel_link}`" target="_blank">
              <Badge class="text-2xl py-4" severity="info">{{
                link.ref_agent.title
                }}</Badge>
            </a>
          </template>
        </div>
        <LoginWidget class="mt-4" corner-radius="10px" :bot-username="authBot" @auth="handleUserAuth"></LoginWidget>
        <Message v-if="errorText" class="ms-1 mt-2" variant="simple" severity="error">{{ $t(errorText) }}</Message>
      </div>
    </div>
  </div>
</template>
